import React, { useCallback, useState } from 'react';
import { Icon } from './Icon';
import { Icons } from './icons';

type Props = {
  text: string;
  className?: string;
  title?: string;
  successDuration?: number;
};

export const CopyToClipboard: React.FC<Props> = ({
  text,
  className = 'h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors duration-150',
  title = 'Copy to clipboard',
  successDuration = 2000,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();

      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), successDuration);
        })
        .catch(err => {
          console.error('Failed to copy text:', err);
        });
    },
    [text, successDuration]
  );

  return (
    <Icon
      icon={copied ? Icons.check : Icons.clipboard}
      className={`${className} ${copied ? 'text-green-500' : ''}`}
      onClick={handleCopy}
      style={{ cursor: 'pointer' }}
    />
  );
};
